// React Lib
import React, { useState } from "react";
// Component Styles
import { useStyles } from "./OpenTicketStyles";
// @otg-one/ui_components/components
import { Typography, Button } from "../index";
// @otg-one/ui_components/constants
import { Color, FONT_FAMILY } from "../../constants";
export const OpenTicket = (props) => {
    const classes = useStyles(props);
    const [isHover, setIsHover] = useState(false);
    const { id, style, ticket, textOpenTickets, textOpenTicketsAvailable, textRegisterToSupportPortal } = props;
    const handleOnMouseOver = () => {
        setIsHover(true);
    };
    const handleOnMouseOut = () => {
        setIsHover(false);
    };
    return (React.createElement("div", { id: `${id}-open-ticket-container`, className: classes.openTicketContainer, onMouseOver: handleOnMouseOver, onMouseOut: handleOnMouseOut, style: style },
        React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_MEDIUM, size: 16, color: isHover ? Color.neutral[0] : Color.primary[600], style: {
                transition: "all .2s ease-in-out",
            } }, textOpenTickets),
        React.createElement("div", { id: `${id}-open-ticket`, className: classes.openTicket },
            React.createElement(Typography, { id: `${id}-open-ticket-count`, fontFamily: FONT_FAMILY.CAPITOLIUM_BOLD, size: 60, color: isHover ? Color.neutral[0] : Color.neutral[800], style: {
                    transition: "all .2s ease-in-out",
                } }, ticket.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")),
            React.createElement(Typography, { fontFamily: FONT_FAMILY.CAPITOLIUM, size: 24, color: isHover ? Color.neutral[0] : Color.primary[600], style: { marginLeft: 8, transition: "all .2s ease-in-out" } }, textOpenTicketsAvailable)),
        isHover ? (React.createElement("a", { target: "_blank", href: "https://support.commsult.de/", style: { textDecoration: "none" } },
            React.createElement(Button, { id: `${id}-open-ticket-button`, type: "secondary", color: "white", alignIcon: "right", style: { marginTop: 20 } }, textRegisterToSupportPortal))) : (React.createElement("a", { target: "_blank", href: "https://support.commsult.de/", style: { textDecoration: "none" } },
            React.createElement(Button, { id: `${id}-open-ticket-button`, type: "secondary", alignIcon: "right", style: { marginTop: 20 } }, textRegisterToSupportPortal)))));
};
OpenTicket.defaultProps = {
    ticket: 300,
    textOpenTickets: 'Open Tickets',
    textOpenTicketsAvailable: 'Open Tickets Available',
    textRegisterToSupportPortal: 'Register to Support Portal'
};
export default React.memo(OpenTicket);
